import { Button, ButtonProps } from 'antd';
import { PieChartOutlined } from '@ant-design/icons';

export type AddReportButtonProps = Omit<ButtonProps, 'icon'>;

export function AddReportButton(props: AddReportButtonProps) {
  return <Button type="default" {...props} icon={<PieChartOutlined />} />;
}
